import axios from 'axios';
import { handleResponse, handleError } from './response';
import * as storageConstants from '../Constants/storageConstant';
import * as commonServices from './common';
import * as urlconstant from '../Constants/urlConstants';

const BASE_URL = urlconstant.BASE_URL;

export const getHeaders = () => {
  return {
    'Accept': 'application/json',
    'Authorization': commonServices.getLocalData(storageConstants.AUTH) !== null ? `Bearer ${commonServices.getLocalData(storageConstants.AUTH)}` : null,
  };
};

/** @param {string} resource */
export const getAll = (resource, model = '') => {
  let headers = getHeaders();
  const startTime = Date.now(); // Track start time
  const url = `${BASE_URL}${resource}${model}`;

  return axios
    .get(url, { headers })
    .then((response) => handleResponse(response, startTime, url))
    .catch((error) => handleError(error, startTime));
};

export const get = (resource, id) => {
  let headers = getHeaders();
  const startTime = Date.now(); // Track start time
  const url = `${BASE_URL}${resource}${id}`;

  return axios
    .get(url, { headers })
    .then((response) => handleResponse(response, startTime, url))
    .catch((error) => handleError(error, startTime));
};

export const post = (resource, model = {}) => {
  let headers = getHeaders();
  const startTime = Date.now(); // Track start time
  const url = `${BASE_URL}${resource}`;

  return axios
    .post(url, model, { headers })
    .then((response) => handleResponse(response, startTime, url))
    .catch((error) => handleError(error, startTime));
};

export const put = (resource, model) => {
  const headers = getHeaders();
  const startTime = Date.now(); // Track start time
  const url = `${BASE_URL}${resource}`;

  return axios
    .put(url, model, { headers })
    .then((response) => handleResponse(response, startTime, url))
    .catch((error) => handleError(error, startTime));
};

export const deleteAPI = (id) => {
  const headers = getHeaders();
  const startTime = Date.now(); // Track start time
  const url = `${BASE_URL}${id}`;

  return axios
    .delete(url, { headers })
    .then((response) => handleResponse(response, startTime, url))
    .catch((error) => handleError(error, startTime));
};
